// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assinged-screen-main {
  overflow-y: scroll;
  overflow-x: hidden;
  height: calc(100vh - 110px) !important;
}
.assinged-screen-main .StatusOutplacementAssignScreen-main .icon {
  background: linear-gradient(45deg, #40c2ff 0%, #32d8d8 100%);
  width: 50px;
  height: 50px;
  border-radius: 50rem;
  padding: 8px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  color: white;
}
.assinged-screen-main .StatusOutplacementAssignScreen-main .accordion-body {
  background-color: #F2F2F7;
}
.assinged-screen-main .StatusOutplacementAssignScreen-main .outplacement-answers .row {
  padding: 0.5rem;
}
.assinged-screen-main .StatusOutplacementAssignScreen-main .outplacement-card {
  background-color: #fff;
  padding: 1rem;
  border-radius: 15px;
  height: 100%;
}
.assinged-screen-main .StatusOutplacementAssignScreen-main .outplacement-mood {
  max-width: 35px;
}
.assinged-screen-main .StatusOnboardingAssignScreen-main .icon {
  background: linear-gradient(45deg, #40c2ff 0%, #32d8d8 100%);
  width: 50px;
  height: 50px;
  border-radius: 50rem;
  padding: 8px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  color: white;
}
.assinged-screen-main .StatusOnboardingAssignScreen-main .accordion-body {
  background-color: #F2F2F7;
}
.assinged-screen-main .StatusOnboardingAssignScreen-main .outplacement-answers .row {
  padding: 0.5rem;
}
.assinged-screen-main .StatusOnboardingAssignScreen-main .outplacement-card {
  background-color: #fff;
  padding: 1rem;
  border-radius: 15px;
  height: 100%;
}
.assinged-screen-main .StatusOnboardingAssignScreen-main .outplacement-mood {
  max-width: 35px;
}
.assinged-screen-main .border-blue {
  border: 2px solid #41c8ff !important;
  border-radius: 15px;
  background-color: white !important;
}
.assinged-screen-main .border-purple {
  border: 2px solid #7a6be8;
  border-radius: 15px;
  background-color: white;
}
.assinged-screen-main .btn-assign-nuevo-colaborador {
  background-color: #7a6be8 !important;
  color: white !important;
  font-weight: 600 !important;
}
.assinged-screen-main .circle-blue {
  background-color: #619cb3 !important;
  padding: 10px;
  height: 15px;
  width: 15px;
}
.assinged-screen-main .btn-assign-edit {
  background: #41c8ff !important;
  color: white !important;
}
.assinged-screen-main .assign-screen-btn-delete {
  background-color: #41c8ff !important;
  color: white !important;
}

.modal-assign .loading {
  width: 100% !important;
  height: 100% !important;
  background: rgb(255, 255, 255);
}
.modal-assign .modal-content {
  border-radius: 2rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}
.modal-assign .assign-modal-main .assign-custom-checkbox {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.modal-assign .assign-modal-main .checkmark {
  padding: 6px 10px;
  display: block;
  height: 25px;
  width: 25px;
  background-color: #d9d9e2;
}
.modal-assign .assign-modal-main .assign-custom-checkbox:hover ~ .checkmark {
  background-color: #9391a1;
}
.modal-assign .assign-modal-main .assign-custom-checkbox:checked ~ .checkmark {
  background-color: #41c8ff;
}
.modal-assign .assign-modal-main .checkmark:after {
  content: " ";
  display: none;
}
.modal-assign .assign-modal-main .assign-custom-checkbox:checked ~ .checkmark:after {
  display: block;
}
.modal-assign .assign-modal-main .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}
.modal-assign .assign-modal-main .checkmark-radio {
  padding: 6px 10px;
  display: block;
  height: 25px;
  width: 25px;
  background-color: #d9d9e2;
  border-radius: 15px;
}
.modal-assign .assign-modal-main .assign-custom-checkbox:hover ~ .checkmark-radio {
  background-color: #9391a1;
}
.modal-assign .assign-modal-main .assign-custom-checkbox:checked ~ .checkmark-radio {
  background-color: #41c8ff;
}
.modal-assign .assign-modal-main .checkmark-radio:after {
  content: " ";
  display: none;
}
.modal-assign .assign-modal-main .assign-custom-checkbox:checked ~ .checkmark-radio:after {
  display: block;
}
.modal-assign .assign-modal-main .checkmark-radio:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}
.modal-assign .assign-delete-modal-btn {
  background-color: #ec6376 !important;
  color: white !important;
}
.modal-assign .assign-mark-del {
  color: #ec6376 !important;
}

.blockui {
  background: #000000;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  position: fixed;
  left: 0px;
  top: 0px;
  right: 0px;
  z-index: 9999 !important;
  cursor: wait;
  margin: 0px;
  padding: 0px;
  overflow-y: hidden;
}
.lds-dual-ring {
  width: 80px;
  height: 80px;
  position: relative;
  margin: 0px auto;
  top: 16rem;
}

.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid #fff;
  border-color: #00555d transparent #008793 transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}

@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.swal2-title {
  font-size: 18px;
}`, "",{"version":3,"sources":["webpack://./src/Views/Services/Components/AssignScreen/Components/AssignScreenComponent.sass"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,kBAAA;EACA,sCAAA;AACJ;AACQ;EACI,4DAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AACZ;AACQ;EACI,yBAAA;AACZ;AAEY;EACI,eAAA;AAAhB;AAEQ;EACI,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAAZ;AACQ;EACI,eAAA;AACZ;AAEQ;EACI,4DAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAAZ;AAEQ;EACI,yBAAA;AAAZ;AAGY;EACI,eAAA;AADhB;AAGQ;EACI,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AADZ;AAEQ;EACI,eAAA;AAAZ;AAKI;EACI,oCAAA;EACA,mBAAA;EACA,kCAAA;AAHR;AAKI;EACI,yBAAA;EACA,mBAAA;EACA,uBAAA;AAHR;AAKI;EACI,oCAAA;EACA,uBAAA;EACA,2BAAA;AAHR;AAKI;EACI,oCAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;AAHR;AAKI;EACI,8BAAA;EACA,uBAAA;AAHR;AAKI;EACI,oCAAA;EACA,uBAAA;AAHR;;AAOI;EACQ,sBAAA;EACA,uBAAA;EACA,8BAAA;AAJZ;AAKI;EACI,mBAAA;EACA,wDAAA;AAHR;AAKQ;EACI,kBAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;AAHZ;AAKQ;EACI,iBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;AAHZ;AAKQ;EACI,yBAAA;AAHZ;AAKQ;EACI,yBAAA;AAHZ;AAKQ;EACI,YAAA;EACA,aAAA;AAHZ;AAKQ;EACI,cAAA;AAHZ;AAKQ;EACI,SAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EAGA,wBAAA;AAHZ;AAKQ;EACI,iBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AAHZ;AAKQ;EACI,yBAAA;AAHZ;AAKQ;EACI,yBAAA;AAHZ;AAKQ;EACI,YAAA;EACA,aAAA;AAHZ;AAKQ;EACI,cAAA;AAHZ;AAKQ;EACI,SAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EAGA,wBAAA;AAHZ;AAKI;EACI,oCAAA;EACA,uBAAA;AAHR;AAKI;EACI,yBAAA;AAHR;;AAKA;EACI,mBAAA;EACA,WAAA;EACA,YAAA;EAEA,YAAA;EAEA,eAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,wBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAHJ;AAKA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;AAHJ;;AAKA;EACI,YAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,qDAAA;EACA,6CAAA;AAFJ;;AAIA;EACI;IACI,uBAAA;EADN;EAGE;IACI,yBAAA;EADN;AACF;AAEA;EACI,eAAA;AAAJ","sourcesContent":[".assinged-screen-main\n    overflow-y: scroll\n    overflow-x: hidden\n    height: calc(100vh - 110px) !important\n    .StatusOutplacementAssignScreen-main\n        & .icon\n            background: linear-gradient(45deg, #40c2ff 0%, #32d8d8 100%)\n            width: 50px\n            height: 50px\n            border-radius: 50rem\n            padding: 8px\n            margin-right: 10px\n            display: flex\n            align-items: center\n            color: white\n\n        & .accordion-body\n            background-color: #F2F2F7\n\n        & .outplacement-answers\n            & .row\n                padding: 0.5rem\n\n        & .outplacement-card\n            background-color: #fff\n            padding: 1rem\n            border-radius: 15px\n            height: 100%\n        & .outplacement-mood\n            max-width: 35px\n\n    .StatusOnboardingAssignScreen-main\n        & .icon\n            background: linear-gradient(45deg, #40c2ff 0%, #32d8d8 100%)\n            width: 50px\n            height: 50px\n            border-radius: 50rem\n            padding: 8px\n            margin-right: 10px\n            display: flex\n            align-items: center\n            color: white\n\n        & .accordion-body\n            background-color: #F2F2F7\n\n        & .outplacement-answers\n            & .row\n                padding: 0.5rem\n\n        & .outplacement-card\n            background-color: #fff\n            padding: 1rem\n            border-radius: 15px\n            height: 100%\n        & .outplacement-mood\n            max-width: 35px\n\n\n\n\n    & .border-blue\n        border: 2px solid #41c8ff !important\n        border-radius: 15px\n        background-color: white !important\n\n    & .border-purple\n        border: 2px solid #7a6be8\n        border-radius: 15px\n        background-color: white\n\n    & .btn-assign-nuevo-colaborador\n        background-color: #7a6be8 !important\n        color: white !important\n        font-weight: 600 !important\n\n    & .circle-blue\n        background-color: #619cb3 !important\n        padding: 10px\n        height: 15px\n        width: 15px\n\n    & .btn-assign-edit\n        background: #41c8ff !important\n        color: white !important\n\n    & .assign-screen-btn-delete\n        background-color: #41c8ff !important\n        color: white !important\n\n.modal-assign\n\n    & .loading\n            width: 100% !important\n            height: 100% !important\n            background: rgba(255,255,255,1)\n    & .modal-content\n        border-radius: 2rem\n        box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important\n    & .assign-modal-main\n        & .assign-custom-checkbox\n            position: absolute\n            opacity: 0\n            cursor: pointer\n            height: 0\n            width: 0\n\n        & .checkmark\n            padding: 6px 10px\n            display: block\n            height: 25px\n            width: 25px\n            background-color: #d9d9e2\n\n        & .assign-custom-checkbox:hover ~ .checkmark\n            background-color: #9391a1\n\n        & .assign-custom-checkbox:checked ~ .checkmark\n            background-color: #41c8ff\n\n        & .checkmark:after\n            content: \" \"\n            display: none\n\n        & .assign-custom-checkbox:checked ~ .checkmark:after\n            display: block\n\n        & .checkmark:after\n            left: 9px\n            top: 5px\n            width: 5px\n            height: 10px\n            border: solid white\n            border-width: 0 3px 3px 0\n            -webkit-transform: rotate(45deg)\n            -ms-transform: rotate(45deg)\n            transform: rotate(45deg)\n\n        & .checkmark-radio\n            padding: 6px 10px\n            display: block\n            height: 25px\n            width: 25px\n            background-color: #d9d9e2\n            border-radius: 15px\n\n        & .assign-custom-checkbox:hover ~ .checkmark-radio\n            background-color: #9391a1\n\n        & .assign-custom-checkbox:checked ~ .checkmark-radio\n            background-color: #41c8ff\n\n        & .checkmark-radio:after\n            content: \" \"\n            display: none\n\n        & .assign-custom-checkbox:checked ~ .checkmark-radio:after\n            display: block\n\n        & .checkmark-radio:after\n            left: 9px\n            top: 5px\n            width: 5px\n            height: 10px\n            border: solid white\n            border-width: 0 3px 3px 0\n            -webkit-transform: rotate(45deg)\n            -ms-transform: rotate(45deg)\n            transform: rotate(45deg)\n\n    & .assign-delete-modal-btn\n        background-color: #ec6376 !important\n        color: white !important\n\n    & .assign-mark-del\n        color: #ec6376 !important\n\n.blockui\n    background:#000000\n    width: 100%\n    height: 100%\n    filter:alpha(opacity=50)\n    opacity:0.5\n    margin: 0px\n    position: fixed\n    left: 0px\n    top: 0px\n    right: 0px\n    z-index:9999 !important\n    cursor: wait\n    margin: 0px\n    padding: 0px\n    overflow-y: hidden\n\n.lds-dual-ring\n    width: 80px\n    height: 80px\n    position: relative\n    margin: 0px auto\n    top: 16rem\n\n.lds-dual-ring:after\n    content: \" \"\n    display: block\n    width: 64px\n    height: 64px\n    margin: 8px\n    border-radius: 50%\n    border: 6px solid #fff\n    border-color: #00555d transparent #008793 transparent\n    animation: lds-dual-ring 1.2s linear infinite\n\n@keyframes lds-dual-ring\n    0%\n        transform: rotate(0deg)\n\n    100%\n        transform: rotate(360deg)\n\n.swal2-title\n    font-size: 18px"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
